import axios from "axios";
import { API_URL } from "../config";
import { user } from "./actions_helper";

export interface IMailTextMessage {
    role: "assistant" | "user";
    content: string;
}

export interface IMailTextRequest {
    messages: IMailTextMessage[];
    instruction?: string;
}

export interface IMailTextResponse {
    content: string;
    messages: IMailTextMessage[];
    doc_type: string;
    model: string;
}

export async function generateMailText(
    entryId: number | string,
    payload: IMailTextRequest
): Promise<IMailTextResponse> {
    const response = await axios.post(
        `${API_URL}/form_entries/${entryId}/mail_text.json`,
        payload,
        { headers: { authorization: user().token } }
    );
    return response.data;
}
